<template>
  <dnd-reorder-element
    :id="undefined"
    :index="inputIndex"
    :highlight-condition="allowHoverAction"
    :hover-condition="() => false"
    :CtcDropCondition="allowHoverAction"
    :CtrDropCondition="() => false"
    :RtrDropCondition="() => false"
    :type="elDragType"
    :into-allowed="false"
    :callback-params="{ elType: 5, innerElementId: this.theModel.Id, viewport: scrollViewport, isEditing }"
    @changePosition="moveStoreItem"
    :draggable="!isEditing"
    class="dnd-element display-ungroup-on-hover"
  >
    <div class="full-width">
      <div class="row no-wrap full-width">
        <div v-if="inputIndex != null" class="q-mr-sm">{{ (inputIndex+1)+'.' }}</div>
        <div v-if="!isEditing" :class="['q-my-none', 'cursor-pointer', 
          { 'text-grey-8': !(theModel as CommonEntity).Name }]"
          @click="startEditing"
        >{{ (theModel as CommonEntity).Name }}
          <!-- <q-popup-edit v-model="(theModel as CommonEntity).Name" auto-save fit v-slot="scope">
            <q-input v-model="(theModel as CommonEntity).Name" outlined dense autofocus 
            debounce="500" no-error-icon @keyup.enter="scope.set" />
          </q-popup-edit> -->
        </div>
        <q-input v-else ref="fname_input" class="thin-input-noborder full-width" clearable autofocus color="white"
          debounce="500" clear-icon="close" outlined dense style="font-size: 12px !important; padding: 0 !important; margin-top: -3px;" 
          hide-bottom-space v-model="(theModel as CommonEntity).Name" no-error-icon
          @keydown.esc="isEditing = false" @blur="isEditing = false" @keydown.enter.stop.prevent="editItem"
        />
        <q-btn
          v-if="!isEditing"
          class="q-px-none q-mx-none unset-items-center"
          flat
          dense
          :aria-label="$t('delete_formula')"
          icon="close"
          size="sm"
          style="margin-top: -2px;"
          tabindex="-1"
          color="accent"
          @click="deleteFormula"
        >
          <q-tooltip :delay="300" anchor="top middle" self="center middle">
            {{ $t('remove') }}
          </q-tooltip>
        </q-btn>
      </div>
      <formula-selector
        v-if="useChartMode"
        class="full-width"
        :input-index="inputIndex"
        :nested-key-name="nestedKeyName"
        :template-name="templateName"
        :global-formulas-mode="true"
        :input-parameter-options="parameterOptions"
        :formula-options="[]"
        :is-incorrect="isIncorrect"
        v-model="(this.theModel as AnalyticsChartElementFormula).Tokens"
        @theOnlyFormulaLeft="updateElementName"
      />
      <formula-selector
        v-else
        class="full-width"
        nested-key-name="RecordFields"
        :input-index="inputIndex"
        :formula-options="formulaOptions"
        :input-parameter-options="undefined"
        :is-incorrect="isIncorrect"
        v-model="(this.theModel as AnalyticsTableFormula).FormulaTokens"
      />
    </div>
  </dnd-reorder-element>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue, Watch } from 'vue-facing-decorator';
import { AnalyticsChartElementFormula, AnalyticsTableFormula } from '@/models/interfaces/entity-settings/parameters/parameters';
import { CommonEntity } from '@/models/interfaces/common';
import FormulaSelector from '@/components/common/formula-selector/FormulaSelector.vue';
import { settingsStore } from '@/store/settings';
// import { storeToRefs } from 'pinia';
// @ts-ignore
import DndReorderElement from '@/components/dnd/DndReorderElement.vue';
import { DragItemTypes } from '@/components/dnd/ItemTypes';
import _ from 'lodash';

type ElementFormula =  AnalyticsTableFormula | AnalyticsChartElementFormula

@Component({
  name: 'FormulaListElement',
  components: { FormulaSelector, DndReorderElement }
})
export default class FormulaListElement extends Vue {
  // v-model
  @Prop({ default: {} as ElementFormula })
  modelValue!: ElementFormula
  @Prop({ default: {} as ElementFormula[] })
  formulaOptions!: ElementFormula[]
  @Prop({ default: 0 })
  inputIndex?: number
  @Prop({ default: false })
  useChartMode!: boolean
  @Prop({ default: undefined })
  scrollViewport?: any
  @Prop()
  allowHoverAction!: (dragParams: any, hoverParams: any) => boolean

  @Prop({ default: [] })
  parameterOptions?: any[]
  @Prop({ default: '' })
  nestedKeyName!: string
  @Prop({ default: '' })
  templateName!: string

  @Emit("update:modelValue") emitModelValue(arg: ElementFormula ) { return arg; }
  @Emit("deleteFormula") emitDeleteFormula(arg: any) { return arg; }
  @Emit("changePosition") emitMoveItem(arg: any) { return arg; }
  @Emit("theOnlyFormulaLeft") emitSingleNameValue(arg: string) { return arg; }

  setstore: any = undefined
  // setstore: any
  isIncorrect: string = ''
  isEditing: boolean = false

  created() {
    this.setstore = settingsStore()
    // this.setstore = storeToRefs(this.setstore);
  }

  mounted() {
    setTimeout(() => {
      // wait 10ms for theModel to fill
      if (this.useChartMode && !(this.theModel as AnalyticsChartElementFormula).Tokens?.length) {
        this.startEditing();
      }

      if (!this.useChartMode && !(this.theModel as AnalyticsTableFormula).FormulaTokens?.length) {
        this.startEditing();
      }
    }, 10)
  }

  get formulaValidationMutated() { return _.cloneDeep(this.setstore?.getFormulaValidation) }

  get elDragType() {
    return DragItemTypes.CARD_ROOT;
  }

  @Watch('formulaValidationMutated', { deep: true })
  updateIncorrect(val: any) {
    if (this.useChartMode) {
      this.isIncorrect = '';
      return
    }

    this.isIncorrect = val.find((el: any) => el.formulaId === this.theModel.Id)?.errorText || ''
  }

  async moveStoreItem(params: any) {
    this.emitMoveItem(params)
  }

  // via input
  startEditing() {
    this.isEditing = true

    const that = this
    this.$nextTick(() => {
      setTimeout(() => {
        if (!that.$refs.fname_input) { return }
        // @ts-ignore
        that.$refs.fname_input.nativeEl.setSelectionRange(0, that.theModel.Name.length);
      }, 10)
    })
  }

  editItem() {
    // 510 in order to set more than the 500ms debounce; because if set earlier, debounce is not fired and the model is not saved
    setTimeout(() => { this.isEditing = false; }, 510);
  }

  updateElementName(val: string) {
    this.emitSingleNameValue(val);
  }

  get theModel(): ElementFormula {
    return this.modelValue
  }

  set theModel(val: ElementFormula) {
    this.emitModelValue(val)
  }

  deleteFormula() {
    this.emitDeleteFormula(undefined)
  }
}
</script>

<style lang="scss">
.setting-selection {
  &--child {
    margin-left: 26px !important;
  }
}

.setting-item {
  .q-item__section--avatar {
    padding-left: 0 !important;
  }
}
</style>